import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useLenis from '../hooks/useLenis';

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    if(lenis) {
      lenis.scrollTo(0);
    }else{
      window.scrollTo(0, 0);
    }
  }, [pathname, lenis]); // Trigger this effect whenever the path changes

  return null; // This component doesn't render anything visible
};

export default ScrollToTop;
